import React, { useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import Loader from "../../Components/Loader";
import { customerServiceService } from '../../Services'
import { toast } from 'react-toastify';


export const EditSalesAndCustomerService = () => {
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const data = history.location.state;
  const initialValues = {
      first_name: data.first_name,
      last_name: data.last_name,
      employee_name: data.employee_name,
      department: data.department,
  }
  let param = new URLSearchParams(history.location.search); 

  let obj = {
    CUSTOMERSERVICE  : 'Customer Service',
    SALES  : 'Sales',
  }

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    employee_name: Yup.string().required("Required"),
    department: Yup.string().required("Required"),
  });

  const onSubmit = (fields) => {
    setLoader(true);
    let postData = {
      ...fields,
      Id:param.get("id"),
    };
    customerServiceService.updateCustomerService(postData).then((res) => {
    	if (res.status) {

    		history.push("/sales-and-customer-service-list");
    		toast.success(res.message);
    		setLoader(false);
    	}
    	else {
    		setLoader(false);
    		toast.error(res.message);
    	}
    });
  };

  const onSelect = (e, values, setValues, name) => {
    setValues({
      ...values,
      [name]: e.value,
    });
  };


  


  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-6">
        <div className="card">
          <div className="card-body">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ errors, values, touched, setValues }) => (
                <Form className="control-form" autoComplete="off">
                  <div className="row">
                    <div className="mb-3 row">
                      <div className="col-3">
                        <label className="form-label">First Name</label>
                      </div>
                      <div className="col-9">
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.first_name && errors.first_name
                              ? " is-invalid"
                              : "")
                          }
                          value={values?.first_name}
                          name="first_name"
                          placeholder="Enter First Name"
                        />
                        {touched.first_name && errors.first_name ? (
                          <div className="text-danger">{errors.first_name}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-3 row">
                      <div className="col-3">
                        <label className="form-label">Last Name</label>
                      </div>
                      <div className="col-9">
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.last_name && errors.last_name
                              ? " is-invalid"
                              : "")
                          }
                          name="last_name"
                          placeholder="Enter Last Name"
                        />
                        {touched.last_name && errors.last_name ? (
                          <div className="text-danger">{errors.last_name}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                  <div className="mb-3 row">
                      <div className="col-3">
                      <label className="form-label">Employee Code</label>
                      </div>
                      <div className="col-9">
                      <Field
                        type="text"
                        className={
                          "form-control" +
                          (touched.employee_name && errors.employee_name
                            ? " is-invalid"
                            : "")
                        }
                        name="employee_name"
                        onChange={(e) => {
                          setValues({...values,[e.target.name]:e.target.value.trim()})
                        }}
                        placeholder="Enter Employee Code"
                      />
                      {touched.employee_name && errors.employee_name ? (
                        <div className="text-danger">
                          {errors.employee_name}
                        </div>
                      ) : null}
                    </div>
                    </div>
                  </div>
                  <div className="row">
                  <div className="mb-3 row">
                      <div className="col-3">
                      <label className="form-label">Department</label>
                      </div>
                      <div className="col-9">
                      <Select
                        name="department"
                        // className={`${errors.department && 'border border-danger rounded' || ''}`}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: `${
                              (errors.department && "#f46a6a") || "#ced4da"
                            }`,
                          }),
                        }}
                        onChange={(e) =>
                          onSelect(e, values, setValues, "department")
                        }
                        options={[
                            { value: "SALES", label: "Sales" },
                            {
                                value: "CUSTOMERSERVICE",
                                label: "Customer Service",
                            },
                        ]}
                        value={{values:values.department,label:obj[values.department]}}
                      />
                      {touched.department && errors.department ? (
                        <div className="text-danger">{errors.department}</div>
                      ) : null}
                    </div>
                    </div>
                  </div>

                  <div className="mt-3 d-flex justify-content-between">
                    <button
                      className="btn btn-danger w-sm waves-effect waves-light"
                      type="button"
                      onClick={() => history.goBack()}
                    >
                      Back
                    </button>
                    <button
                      className="btn btn-primary w-sm waves-effect waves-light"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </Form>
              )}
            </Formik>

            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};
